module.exports = __webpack_public_path__ + "media/images/skype-5536b606fd50302fc994fb8e6bf3e635.png";